if (!customElements.get('wls-manuals')) {
    class WLSManuals extends HTMLElement {
        constructor() {
            super();
            this.tabs = this.querySelectorAll('.js-manuals-tab');
            this.onTabClick = this.onTabClick.bind(this);
            this.onVideoPlay = this.onVideoPlay.bind(this);
        }

        connectedCallback() {
            this.syncAriaSelected();
            this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));          
            this.addEventListener('play', this.onVideoPlay, true);
        }

        disconnectedCallback() {
            this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
            this.removeEventListener('play', this.onVideoPlay, true);
        }

        onVideoPlay(event) {
            const playing = event.target;
            this.querySelectorAll('video').forEach((video) => {
                if (video !== playing) video.pause();
            });
        }

        onTabClick(event) {
            const target = event.currentTarget.dataset.tabTarget;
            if (!target || target === this.dataset.activeTab) return;
            this.dataset.activeTab = target;
            this.syncAriaSelected();
        }

        syncAriaSelected() {
            const active = this.dataset.activeTab;
            this.tabs.forEach((tab) => {
                tab.setAttribute('aria-selected', tab.dataset.tabTarget === active ? 'true' : 'false');
            });
        }
    }

    customElements.define('wls-manuals', WLSManuals);
}
